import React, { useEffect } from "react";
import { connect, useSelector, useDispatch } from "react-redux";
import { Card, Accordion, Form, InputGroup } from "react-bootstrap";

import TutorialPopup from "../../help/TutorialPopup";
import * as HelpContent from "../../../utils/HelpContent";
import { CHANGE_ORDER_TYPE_EXIT_RENT, CHANGE_ORDER_TYPE_RENT, CHANGE_RENT_FUND, CLOSE_DEAL_END_OF_TRADING_DAY_RENT, SET_STOP_AFTER_DEAL_RENT } from "../../../actions/create-bot-type";
import { isLong, isMarginShort, restrictAlphabets, isLockedDayTraderTemplate } from "../../../utils/Utils";
import { formatNumberToString } from "../../../utils/Utils";
import LeftRightForm from "../../bots/new-bot/modules/LeftRightForm";
import CustomCheckbox from "../../bots/new-bot/modules/CustomCheckbox";
import ExtendedTradingHours from "../../bots/new-bot/modules/ExtendedTradingHours";
import TwentyFourHoursTrading from "../../bots/new-bot/modules/TwentyFourHoursTrading";
import DisableFractionalPurchase from "../../bots/new-bot/modules/DisableFractionalPurchase";
import BooleanView from "../../bots/new-bot/BooleanView";
import CreateRentBotSection from "../../bots/new-bot/modules/CreateRentBotSection";
import SendOrderFilledEmail from "../../bots/new-bot/modules/SendOrderFilledEmail";
import SendOrderFilledPhone from "../../bots/new-bot/modules/SendOrderFilledPhone";
import BaseOrderTypeModule from "../../bots/new-bot/modules/BaseOrderTypeModule";
import AutoClosePosEndOfTheDay from "../../bots/new-bot/modules/AutoClosePosEndOfTheDay";
import MaxContracts from "../../bots/new-bot/modules/MaxContracts";
import DisableStopLoss from "../../bots/new-bot/modules/DisableStopLoss";

const TradeParamsViewRent = (props) => {
  const { editing,t,step } = props;
  const rental = useSelector((state) => state.createBot.rentBot.rental);
  const rentBot = useSelector((state) => state.createBot.rentBot);
  const stopBotAfterDeal = rentBot.stopBotAfterDeal?true:false;
  const isLockedTemplate = isLockedDayTraderTemplate(rentBot);
  const fund = rentBot.initFund;
  const isEditing = rentBot.isEditing;
  const strategy = editing?rentBot.strategy:rentBot.strategy?rentBot.strategy:rental && rental.template.strategy
  const currentCoin = (isLong(editing?rentBot.strategy:rental && rental.template.strategy) || isMarginShort(strategy))
    ? rentBot.quoteCoin
    : rentBot.baseCoin;
  const balances = useSelector((state) => state.bots.balances);
  const pairData = useSelector((state) => state.bots.pairData);
  const balance =
    balances && balances.find((item) => item.coin === currentCoin);
  const dispatch = useDispatch();
  useEffect(() => {
    if (balance && !editing && !rentBot.initFund) {
      //fundChanged(parseFloat(balance.free).toFixed(2));
    }
  }, [balance]);

  const fundChanged = (val) => {
    dispatch({
      type: CHANGE_RENT_FUND,
      payload: val,
    });
  };
  const orderTypeChanged = (orderType) => {
    dispatch({
      type: CHANGE_ORDER_TYPE_RENT,
      payload: orderType,
    });
  };
  const exitOrderTypeChanged = (orderType) => {
    dispatch({
      type: CHANGE_ORDER_TYPE_EXIT_RENT,
      payload: orderType,
    });
  };
  const setDealStopValue = (val) => {
      dispatch({
        type: SET_STOP_AFTER_DEAL_RENT,
        payload: val?1:0,
      });
    };

  return (
    <div className="ba-asset-form-content">
        <div className="row gx-0 gy-3">
      <LeftRightForm
        left={<><Form.Label>
          {t("fund-alloc")} <TutorialPopup content={t("initFund-help")} />
          </Form.Label></>}
        right={<><label data-text={currentCoin} className="input-gp-label">
        <Form.Control
            as="input"
            type="number"
            placeholder="1000"
            value={fund}
            onChange={(e) => {
              fundChanged(e.target.value);
            }}
            onKeyPress={(e) => {
              restrictAlphabets(e);
            }}
            className="input-text input-gp-text"
          ></Form.Control>
      </label>
      <p style={{ fontSize: 13, marginTop: 10 }}>
                {pairData && pairData.native_coin !='USD' ? <>{t("available")}: {formatNumberToString(balance && balance.free,2)}{" "} 
                {currentCoin} {", "} {formatNumberToString(pairData && pairData.native_balance)}{" "} {pairData && pairData.native_coin} (~{pairData && (pairData.native_balance * pairData.native_quote_rate)} {" "} USD)</>:<>{t("available")}: {formatNumberToString(balance && balance.free,2)}{" "} 
                {currentCoin} {" "}</>} </p>
      </>}
      ></LeftRightForm>
      <MaxContracts rent={true}></MaxContracts>
      <div style={{ marginTop: 20 }}>
            
            <BooleanView
                title={t("entry-order-type")}
                firstButton="market"
                secondButton="limit"
                selected={rentBot.tradeOrderType}
                onSelect={orderTypeChanged}
                customClass="blue-green"
                tutorial={<TutorialPopup content={t("orderType")} />}
              />
           
            </div>
            <div style={{ marginTop: 20 }}>
               <BooleanView
                title={t("exit-order-type")}
                firstButton="market"
                secondButton="limit"
                selected={rentBot.tradeOrderTypeExit}
                onSelect={exitOrderTypeChanged}
                customClass="blue-green"
                tutorial={<TutorialPopup content={t("orderType")} />}
              />
            </div>
            <div style={{ marginTop: 20 }}>
      {/* <BaseOrderTypeModule rent={true}></BaseOrderTypeModule> */}
      </div>
      <LeftRightForm 
        right={<div className="d-flex align-items-center dis-bot-stop-loss mt-3">
                 
       <AutoClosePosEndOfTheDay rent={true}></AutoClosePosEndOfTheDay>
      
      </div>}
      ></LeftRightForm>
            
      
        <ExtendedTradingHours rent={true}></ExtendedTradingHours>
        {rentBot.is247 && !isLockedTemplate ?
        <TwentyFourHoursTrading rent={true}></TwentyFourHoursTrading> :<></>}
        <DisableFractionalPurchase rent={true}></DisableFractionalPurchase>
        {!isLockedTemplate && <DisableStopLoss rent={true}></DisableStopLoss> }
        <LeftRightForm 
            left={<></>}
            right={  <CustomCheckbox 
              val={stopBotAfterDeal} 
              checked={stopBotAfterDeal} 
              callback={setDealStopValue}
              label={t("stop-bot-after-deal-ends")}
              id={'stop-bot-after-deal-ends'}
              >
            </CustomCheckbox>}
            >
            </LeftRightForm>
       <SendOrderFilledEmail rent={true}></SendOrderFilledEmail>
       <SendOrderFilledPhone rent={true}></SendOrderFilledPhone>
        <div className="col-lg-12">
							<div className="bas-asset-submit bas-asset-btn2 bas-asset-btn3">
              <button onClick={()=>step('prev')}>Previous</button>
              {isEditing ? (
                <button type="button" onClick={()=>step('next')}>Next</button>
              ) : (
                <CreateRentBotSection rentBot={rentBot}></CreateRentBotSection>
              )}
            </div>
          </div>
          
    </div>
    </div>
  );
};

export default connect(null)(TradeParamsViewRent);
